import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "footer-container"
}
const _hoisted_2 = {
  key: 1,
  style: {"display":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!

  return (_ctx.state.build.info.phase === 'create')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_GenericButton, {
          text: "CREATE CHARACTER",
          title: _ctx.disableSubmit() ? 'Spend your Char Points in the SPECIAL panel and tag 3 Skills' : 'Click to create your character',
          "is-disabled": _ctx.disableSubmit(),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.disableSubmit() && _ctx.createChar())),
          "full-height": "",
          "full-width": "",
          "font-size": "24px"
        }, null, 8, ["title", "is-disabled"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2))
}